import script from "./DeleteDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./DeleteDashboardModal.vue?vue&type=style&index=0&id=ff6ac518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff6ac518"]])

export default __exports__